import { render, staticRenderFns } from "./incometaxProof.vue?vue&type=template&id=08e9216f&scoped=true"
import script from "./incometaxProof.vue?vue&type=script&lang=js"
export * from "./incometaxProof.vue?vue&type=script&lang=js"
import style0 from "./incometaxProof.vue?vue&type=style&index=0&id=08e9216f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e9216f",
  null
  
)

export default component.exports